import {useLocation} from "react-router-dom";
import {useEffect} from "react";
import AppInfoFile from 'app_info.json';
import useApp from "../../hooks/useApp";

/**
 * 렌딩페이지
 * App 스키마로 이동 실패시 다운로드 페이지로 이동
 * 2022.10.25 LBJ
 */
const MoneeyLanding = () => {
    const App = useApp();
    const location = useLocation()
    // const navigate = useNavigate();

    const sid = location.pathname.split("/")[2];
    console.log("pathname", location.pathname);
    console.log("sid", sid);

    const mobileInstall = () => {
        const iosList = ["iPhone", "iPod", "iPad", "Mac"];
        const iosName = iosList.filter(name => navigator.userAgent.match(name));

        console.log("iosName.length", iosName.length)

        if (iosName.length === 0) {
            window.location = AppInfoFile.appInfo.android.updateUrl;
        } else {
            window.location = AppInfoFile.appInfo.ios.updateUrl;
        }

    }

    useEffect(() => {
        App.setHeader({
            show: false,
            title: <></>,
            left: undefined,
            right: undefined
        })
        App.setShowNav(false)
        App.setMainClass("white")

        //navigate("/dataCertificate", {state: {id: sid}});
        window.location = `moneey://dataCertificate?id=${sid}`;
        console.log("open failed")
        // 이동 실패했다면 인스톨로
        setTimeout(function() {
          mobileInstall();
        }, 1000);
    }, [])

    return <div>
        <p>{location.pathname}</p>
        <h1> Loading...</h1>
    </div>
}

export default MoneeyLanding;